import React from 'react';

export const OUT_OF_CREDITS_TEXT = `Render this presto template now for use for your display? By agreeing to render, you are allocating
one of your available content download credits. Any future changes to this template will require
a re-rendering and will use 1 additional content download credit.`;

export const CANNOT_ADD_SIGN_TEXT = (<div>Currently, your plan does not allow the addition of more sign profiles. <br />
For assistance or to explore plan upgrades that enable more signs,
please contact our support team at <a href="mailto:support@projectcontent.com">support@projectcontent.com</a></div>);
